var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91667 22.7778C5.91667 23.192 6.25245 23.5278 6.66667 23.5278C7.08088 23.5278 7.41667 23.192 7.41667 22.7778H5.91667ZM14.5833 22.7778C14.5833 23.192 14.9191 23.5278 15.3333 23.5278C15.7475 23.5278 16.0833 23.192 16.0833 22.7778H14.5833ZM7 2.19446H15V0.694458H7V2.19446ZM16.25 3.44446V19.7778H17.75V3.44446H16.25ZM5.75 19.7778V9.77779H4.25V19.7778H5.75ZM5.75 9.77779V3.44446H4.25V9.77779H5.75ZM5 10.5278H16.6667V9.02779H5V10.5278ZM5.91667 21.4445V22.7778H7.41667V21.4445H5.91667ZM15.3333 20.6945H6.66667V22.1945H15.3333V20.6945ZM14.5833 21.4445V22.7778H16.0833V21.4445H14.5833ZM4.25 19.7778C4.25 21.1125 5.33198 22.1945 6.66667 22.1945V20.6945C6.16041 20.6945 5.75 20.2841 5.75 19.7778H4.25ZM16.25 19.7778C16.25 20.2841 15.8396 20.6945 15.3333 20.6945V22.1945C16.668 22.1945 17.75 21.1125 17.75 19.7778H16.25ZM15 2.19446C15.6904 2.19446 16.25 2.7541 16.25 3.44446H17.75C17.75 1.92567 16.5188 0.694458 15 0.694458V2.19446ZM7 0.694458C5.48122 0.694458 4.25 1.92568 4.25 3.44446H5.75C5.75 2.7541 6.30964 2.19446 7 2.19446V0.694458Z",
    fill: "#BF9A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 12.1313V16.1111M7.66675 7.29872V4.11108",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.18d41bd712c39b42a53cb99b9cfb77bc.svg";
export { ForwardRef as ReactComponent };